
import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import './style/lib/animate.css';
import { Provider } from 'react-redux';

import { AppContainer } from 'react-hot-loader';
import { isDev } from "./utils/index";
import Page from './Page';
import store from './store';



const render = Component => {
    ReactDOM.render(
        <AppContainer>
            <Provider store={store}>
                <Component store={store} />
            </Provider>
        </AppContainer>
        ,
        document.getElementById('root')
    );
};
render(Page);

// 增加react-hot-loader保持状态刷新操作
if (module.hot) {
    const orgError = console.error; // eslint-disable-line no-console
    console.error = (...args) => { // eslint-disable-line no-console
        if (args && args.length === 1 && typeof args[0] === 'string' && args[0].indexOf('You cannot change <Router routes>;') > -1) {
            // React route changed
        } else {
            orgError.apply(console, args);
        }
    };
    module.hot.accept('./Page', () => {
        render(Page);
    })
}
isDev() && registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js